<template>
    <div class="error404">
        <div class="page-404-content">
            <div class="container">
                <div class="row full-height">
                    <div class="col-md-12 text-center">
                        <div class="error-image section-space--mb_50">
                            <img class="img-fluid" src="../../assets/img/other/4040.png" alt="Image Not Found">
                            <h1 class="error-404-title font-weight--light">Oops, something went wrong.</h1>
                            <p>The page you requested could not be found.</p>
                            <router-link class="error-btn ht-btn-md" to="/">
                                Back to homepage
                            </router-link>
                        </div>
                        
                        <!-- <div class="error-buttons section-space--mt_50">
                            <router-link class="ht-btn ht-btn-md" to="/">
                                 <span class="button-icon mr-2">
                                    <i class="fa fa-home"></i>
                                </span>
                                <span class="button-text">Go back to homepage</span>
                            </router-link>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound',

        metaInfo: {
            title: 'PlusMInus - Page Not found',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    }
</script>
<style>
    .error404 {
        background: #E5E5E5 url("../../assets/img/other/404-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .error-image {
        background: #fff;
        border-radius: 15px;
        padding: 30px;
        position: relative;
        min-height: 400px;    
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 75px;

    }
    .error-image p {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        letter-spacing: 0.05em;
        color: #214F4D;
    }
    .error404 .error-image img {
        max-width: 80%;
        position: absolute;
        top: -220px;
        left: 50%;
        transform: translateX(-50%);
    }
    .error-404-title {
        font-family: 'Nunito Sans', sans-serif;
        font-style: normal;
        font-weight: 900;
        font-size: 55px;
        line-height: 70px;
        color: #214F4D; 
    }
    .error-btn {
        width: 294px;
        height: 76px;
        background: #214F4D;
        border-radius: 38px;
        font-weight: bold;
        font-size: 24px;
        line-height: 74px;
        letter-spacing: 0.05em;
        color: #FFFFFF;
        transition: all ease-in-out 0.3s;
    }
    .error-btn:hover {
        box-shadow: 0px 4px 7px 1px #214f4d;
        color: #fff;
        transition: all ease-in-out 0.3s;
    }
    @media screen and (max-width:767px) {
        .error404 {
            background: #e5e5e5 url("../../assets/img/other/404-mob-bg.png");
            background-repeat: no-repeat;
            background-size: cover;
        }
        .error-image {
            padding: 15px;
        }
        .error404 .error-image img {
            top: -100px;
        }
        .error-404-title {
            text-align: left;
            font-size: 48px;
            line-height: 60px;
        }
        .error-image p {
            text-align: left;
        }
        .error-btn {
            font-size: 18px;
        }
    }
</style>